import { Link } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleCard from "@/components/feature/ArticleCard";
import BackToTop from "@/components/base/BackToTop";
import SEOMeta from "@/components/base/SEOMeta";
import { categories, articles, faqData } from "@/mocks/articles";

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const featuredArticles = articles.slice(0, 6);
  const latestArticles = articles.slice(0, 9);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };

  const webSiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "B站暴躁少女CSGO视频专题站",
    url: "https://baozhaocsgo.cn",
    description: "B站暴躁少女CSGO视频专题站，汇聚CSGO精彩操作、搞笑集锦、新手教学、赛事资讯。了解热门视频内容、观看方法与常见问题。",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://baozhaocsgo.cn/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }} />
      <SEOMeta
        description="B站暴躁少女CSGO视频专题站，汇聚CSGO精彩操作、搞笑集锦、新手教学、赛事资讯。了解热门视频内容、观看方法与常见问题，发现更多值得关注的CSGO资讯。"
        keywords="B站暴躁少女CSGO视频,CSGO,暴躁少女,视频,热门内容,最新资讯,观看指南,精彩操作,搞笑集锦,新手教学"
      />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dynamic%20gaming%20atmosphere%20with%20warm%20orange%20and%20amber%20gradient%20abstract%20background%2C%20esports%20competitive%20vibe%2C%20geometric%20patterns%20inspired%20by%20gaming%20aesthetics%2C%20subtle%20keyboard%20and%20mouse%20silhouettes%2C%20clean%20modern%20design%2C%20cinematic%20lighting%20with%20warm%20golden%20accents%2C%20professional%20esports%20broadcast%20style&width=1800&height=800&seq=hero-bg-2026&orientation=landscape"
              alt="B站暴躁少女CSGO视频专题站"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
          </div>
          <div className="relative z-10 text-center px-4 md:px-6 w-full max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-300/30 mb-6">
              <i className="ri-fire-line text-accent-400"></i>
              <span className="text-sm font-medium text-accent-200 whitespace-nowrap">2026 最新视频更新中</span>
            </div>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
              B站暴躁少女CSGO视频
            </h1>
            <p className="text-lg md:text-xl text-background-100/90 mb-8 max-w-2xl mx-auto leading-relaxed">
              精选CSGO视频内容、最新资讯与观看指南。汇聚<strong>暴躁少女</strong>的精彩操作、搞笑集锦与新手教学，发现更多值得关注的<strong>CSGO视频</strong>内容。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 flex-wrap">
              <Link
                to="/category/jingcai"
                className="px-6 py-3 rounded-md bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
              >
                <i className="ri-play-circle-line mr-2"></i>观看精彩操作
              </Link>
              <Link
                to="/category/xinshou"
                className="px-6 py-3 rounded-md bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold hover:bg-background-50/20 transition-colors duration-200 whitespace-nowrap"
              >
                <i className="ri-guide-line mr-2"></i>新手教学入门
              </Link>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="py-14 md:py-20 bg-background-50" id="video-categories">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                视频分类
              </h2>
              <p className="text-foreground-600 max-w-lg mx-auto">
                按你的兴趣浏览不同分类的CSGO视频内容
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 border border-background-200 rounded-lg p-5 text-center hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300"
                >
                  <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className={`text-2xl ${
                      cat.slug === "baozhao" ? "ri-emotion-line" :
                      cat.slug === "jingcai" ? "ri-star-line" :
                      cat.slug === "gaoxiao" ? "ri-emotion-happy-line" :
                      cat.slug === "xinshou" ? "ri-book-open-line" :
                      "ri-newspaper-line"
                    }`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">{cat.name}</h3>
                  <p className="text-xs text-foreground-500 line-clamp-2">{cat.description}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                  精选内容
                </h2>
                <p className="text-foreground-600">编辑推荐的优质视频内容</p>
              </div>
              <Link
                to="/category/jingcai"
                className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                查看更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {featuredArticles.map((article) => (
                <ArticleCard
                  key={article.id}
                  slug={article.slug}
                  title={article.title}
                  excerpt={article.excerpt}
                  image={article.image}
                  date={article.date}
                  categoryName={article.categoryName}
                  categorySlug={article.category}
                  tags={article.tags}
                  views={article.views}
                  likes={article.likes}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Latest Articles */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                  最新文章
                </h2>
                <p className="text-foreground-600">持续更新的CSGO视频资讯</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {latestArticles.map((article) => (
                <ArticleCard
                  key={article.id}
                  slug={article.slug}
                  title={article.title}
                  excerpt={article.excerpt}
                  image={article.image}
                  date={article.date}
                  categoryName={article.categoryName}
                  categorySlug={article.category}
                  tags={article.tags}
                  views={article.views}
                  likes={article.likes}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Newsletter */}
        <section className="py-14 md:py-20 bg-secondary-50">
          <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
            <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className="ri-mail-send-line text-2xl"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              订阅更新通知
            </h2>
            <p className="text-foreground-600 mb-8">
              第一时间获取暴躁少女最新CSGO视频内容和赛事资讯
            </p>
            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d9ic3oec26n1c7c5ps00"
              method="POST"
              className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);
                const honeypot = formData.get("mobile_alt") as string;
                if (honeypot && honeypot.trim() !== "") {
                  const msg = document.getElementById("newsletter-msg");
                  if (msg) { msg.textContent = "订阅成功！感谢您的关注。"; msg.className = "mt-4 text-sm text-green-600"; }
                  form.reset();
                  return;
                }
                formData.delete("mobile_alt");
                try {
                  const res = await fetch(form.action, {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                  });
                  const responseText = await res.text();
                  let parsed;
                  try { parsed = JSON.parse(responseText); } catch { parsed = null; }
                  const msg = document.getElementById("newsletter-msg");
                  if (res.ok && parsed?.code === "OK") {
                    if (msg) { msg.textContent = "订阅成功！感谢您的关注。"; msg.className = "mt-4 text-sm text-green-600"; }
                    form.reset();
                  } else {
                    const errMsg = parsed?.meta?.message || parsed?.message || "订阅失败，请稍后重试。";
                    if (msg) { msg.textContent = errMsg; msg.className = "mt-4 text-sm text-red-500"; }
                  }
                } catch {
                  const msg = document.getElementById("newsletter-msg");
                  if (msg) { msg.textContent = "网络错误，请稍后重试。"; msg.className = "mt-4 text-sm text-red-500"; }
                }
              }}
            >
              <input
                type="email"
                name="email"
                required
                placeholder="输入你的邮箱地址"
                className="flex-1 px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent"
              />
              <input
                type="text"
                name="mobile_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="contact-alt-field"
              />
              <button
                type="submit"
                className="px-6 py-3 rounded-md bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                立即订阅
              </button>
            </form>
            <div id="newsletter-msg"></div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-14 md:py-20 bg-background-50" id="faq-section">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                常见问题
              </h2>
              <p className="text-foreground-600">关于暴躁少女CSGO视频，你想知道的都在这里</p>
            </div>
            <div className="space-y-4">
              {faqData.map((item, index) => (
                <details
                  key={index}
                  className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden"
                >
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors">
                    <h4 className="text-sm md:text-base font-medium text-foreground-900 pr-4">{item.question}</h4>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200 flex-shrink-0"></i>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <BackToTop />
    </>
  );
}